import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';

const hiddenProximityIdsSelector = (state: AppState) => state.map.mapSettings.data.toolsState.visibility.hiddenProximityIds;
export const useHiddenProximityIdsSelector = () => useSelector(hiddenProximityIdsSelector);

const hiddenHeatmapIdsSelector = (state: AppState) => state.map.mapSettings.data.toolsState.visibility.hiddenHeatmapIds;
export const useHiddenHeatmapIdsSelector = () => useSelector(hiddenHeatmapIdsSelector);

export const hiddenRouteIdsSelector = (state: AppState) => state.map.mapSettings.data.toolsState.visibility.hiddenRouteIds;
export const useHiddenRouteIdsSelector = () => useSelector(hiddenRouteIdsSelector);

export const hiddenPlaceSearchIdsSelector = (state: AppState) => state.map.mapSettings.data.toolsState.visibility.hiddenPlaceSearchIds;
export const useHiddenPlaceSearchIdsSelector = () => useSelector(hiddenPlaceSearchIdsSelector);
